const TrialezeLogo = ({ className = "", size = "default", showText = false }) => {
  const sizes = {
    small: { height: 32, width: 32 },
    default: { height: 44, width: 44 },
    large: { height: 64, width: 64 },
    xl: { height: 80, width: 80 }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="/trialeze-logo.png" 
        alt="Trialeze" 
        style={{ 
          height: s.height, 
          width: s.width,
          objectFit: 'contain',
          borderRadius: '8px'
        }}
      />
      {showText && (
        <div>
          <div className="font-extrabold text-xl" style={{ color: '#0EA5E9' }}>Trialeze</div>
          <div className="text-xs" style={{ color: '#38BDF8' }}>Predict. Strategize. Win.</div>
        </div>
      )}
    </div>
  );
};

export default TrialezeLogo;
